import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface Testimonial {
  id: number;
  name: string;
  role: string;
  company: string;
  content: string;
  rating: number;
  image: string;
  alt: string;
}

const testimonials: Testimonial[] = [
{
  id: 1,
  name: "Sarah Mitchell",
  role: "Property Manager",
  company: "Vancouver Commercial Properties",
  content: "OS Property Services has been our go-to maintenance partner for three years. Their 24/7 WhatsApp response is a game-changer—we get immediate answers even during emergencies. The quality of work is consistently excellent.",
  rating: 5,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ffde516e-1763293580273.png",
  alt: "Professional woman with brown hair in navy blazer smiling at camera in modern office"
},
{
  id: 2,
  name: "David Chen",
  role: "Facilities Manager",
  company: "Metro Strata Management",
  content: "What sets OS Property apart is their preventative approach. They don't just fix problems—they help us avoid them. The maintenance programs have saved our strata thousands in emergency repairs.",
  rating: 5,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_182711c5a-1763295572693.png",
  alt: "Asian man in white dress shirt with glasses smiling in bright office setting"
},
{
  id: 3,
  name: "Jennifer Rodriguez",
  role: "Building Owner",
  company: "Richmond Commercial Holdings",
  content: "Reliability is everything in property maintenance, and OS Property delivers every time. From routine landscaping to emergency plumbing, they handle it all professionally. Highly recommend for any commercial property owner.",
  rating: 5,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_15b464a88-1763295144595.png",
  alt: "Hispanic woman with long dark hair in professional attire smiling confidently"
}];


export default function Testimonials() {
  return (
    <section className="py-16 md:py-24 bg-surface">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-text-primary mb-4">
            What Our Clients Say
          </h2>
          <p className="text-lg text-text-secondary">
            Don't just take our word for it—hear from property managers and building owners who trust us with their most valuable assets.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {testimonials.map((testimonial) =>
          <div
            key={testimonial.id}
            className="bg-background border border-border rounded-xl p-6 hover:shadow-lg transition-all duration-300">

              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, index) =>
              <Icon key={index} name="StarIcon" size={20} variant="solid" className="text-warning" />
              )}
              </div>
              
              <p className="text-text-secondary leading-relaxed mb-6 italic">
                "{testimonial.content}"
              </p>
              
              <div className="flex items-center gap-3 pt-4 border-t border-border">
                <div className="relative w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <AppImage
                  src={testimonial.image}
                  alt={testimonial.alt}
                  className="w-full h-full object-cover" />

                </div>
                <div>
                  <p className="font-semibold text-text-primary">{testimonial.name}</p>
                  <p className="text-sm text-text-secondary">{testimonial.role}</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

}